<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("p0351.invoiceInquiry") }}</span>
    </p>
    <el-col :span="22" :offset="1">
      <el-tabs
        style="min-width: 1000px; user-select: none"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="$t('p0351.notIssued')" name="first">
          <p0352 ref="first"></p0352>
        </el-tab-pane>
        <el-tab-pane :label="$t('p0351.issued')" name="second">
          <p0353 ref="second"></p0353>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </div>
</template>

<script>
import p0352 from "../GreenJacketForum//P0352.vue";
import p0353 from "../GreenJacketForum//P0353.vue";
export default {
  components: {
    p0352,
    p0353
  },
  data() {
    return {
      // 活跃的标签
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {
      this.$refs[this.activeName].init(true);
      console.log(tab, event);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0351.vue